// src/contexts/PaymentContext.tsx

import React, { createContext, useState, ReactNode } from "react";
import { Payment } from "square";

interface PaymentContextType {
  receiptDetails: Payment | null;
  setReceiptDetails: React.Dispatch<React.SetStateAction<Payment | null>>;
  errorMessage: string | null;
  setErrorMessage: React.Dispatch<React.SetStateAction<string | null>>;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export const PaymentProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [receiptDetails, setReceiptDetails] = useState<Payment>({});
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  return (
    <PaymentContext.Provider
      value={{
        receiptDetails,
        setReceiptDetails,
        errorMessage,
        setErrorMessage,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayment = () => {
  const context = React.useContext(PaymentContext);
  if (context === undefined) {
    throw new Error("usePayment must be used within a PaymentProvider");
  }
  return context;
};
